// Has to be in sync with backend
// Currently we only have one action, so the fact that value is just 'submit' and doesn't really matter
// If new actions are added we should use proper action names in FE and BE
export const ReCaptchaActions = {
  ShareMap: 'submit',
} as const;
